module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Corporate-collage.f2050d7b.jpg";